import React from "react";
import styles from "./styles/style.module.scss";
import { Container } from "react-bootstrap";
import Image from "next/image";
import { useRouter } from "next/router";
import { FormattedMessage } from "react-intl";
import Link from "next/link";
import { handleImage } from "@/src/components/handlers";
import { buildWhatsAppUrl } from "@/src/utils/whatsapp.mjs";

const SingleBlog = ({ singleBlog, blogCategory, siteInfo }) => {
  const { locale } = useRouter();

  const formatDate = (dateString, locale) => {
    return new Intl.DateTimeFormat(
      locale === "ar" ? "ar-EG-u-nu-latn" : "en-GB-u-nu-latn",
      {
        day: "numeric",
        month: "long",
        year: "numeric",
      }
    ).format(new Date(dateString));
  };

  return (
    <div className={`${styles["single-blog"]}`}>
      <Container className="mt-5">
        <div className="blog-container">
          <div className="blog-wrapper">
            <div className="blog-image">
              <Image
                src={handleImage(singleBlog?.image)}
                width={600}
                height={400}
                unoptimized
                alt={singleBlog?.title?.[locale]}
                priority
              />
            </div>
            <div className="blog-title">
              <h2>{singleBlog?.title?.[locale]}</h2>
            </div>
            <div className="blog-info">
              {blogCategory && (
                <div className="blog-category">
                  <h4>
                    <b>
                      <FormattedMessage id="category" />:{" "}
                    </b>
                    <Link
                      href={`/blogs/category/${blogCategory?.id}`}
                      aria-label={`Link to category ${
                        blogCategory?.title?.[locale] || ""
                      }`}
                    >
                      <span>{blogCategory?.title?.[locale]}</span>
                    </Link>
                  </h4>
                </div>
              )}
              {singleBlog?.createdAt && (
                <div className="blog-category date">
                  <h4>
                    <b>
                      <FormattedMessage id="PublishDate" />:{" "}
                    </b>
                    <span locale={locale}>
                      {formatDate(singleBlog?.createdAt, locale)}
                    </span>
                  </h4>
                </div>
              )}
            </div>
            <div className="blog-description">
              <div
                dangerouslySetInnerHTML={{
                  __html: singleBlog?.description?.[locale],
                }}
              />
            </div>
            <div className="blog-btns">
              <Link
                href={buildWhatsAppUrl(siteInfo?.whatsup)}
                target="_blank"
                className="whatsapp rounded-5"
              >
                <FormattedMessage id="freeConsultation" />
              </Link>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default SingleBlog;
